import { Component } from '@angular/core'

import { QuestionTypeView, QuestionViewService, IQuestionAnswer } from '../'

@Component({
  selector: 'mp-multiple-choice-question-view',
  templateUrl: './multiple-choice-question-view.html'
})
export class MultipleChoiceQuestionViewComponent extends QuestionTypeView {

  public constructor(
     _questionViewService: QuestionViewService
  ) { super(_questionViewService) }

  public onOptionSelected(questionAnswer: IQuestionAnswer) {
    this._questionViewService.questionAnswered.emit([questionAnswer])
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/multiple-choice-question-view/multiple-choice-question-view.component.ts